import DashboardRoleTableDto from 'app/admin/user/dto/DashboardRoleTableDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class DashboardRoleTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'dashboardRoleTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<DashboardRoleTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, DashboardRoleTableDto)))
				.catch(reject);
		});
	}
}

export default new DashboardRoleTableService();
